module.exports = __webpack_public_path__ + "static/media/icon-social_media-instagram.a8f8d712.svg";